// extracted by mini-css-extract-plugin
export default {"descriptions":"qJkjR","descriptions--top":"nK3hQ","description":"jhQd0","icon":"Yk1WV","icon__img":"VHVIj"};